/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-return-assign */
/* eslint-disable no-constant-condition */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  Row,
  Col,
  Navbar,
  NavDropdown,
  OverlayTrigger,
  Tooltip,
  Overlay,
} from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  MdMenu,
  MdLogout,
  MdAccountBalanceWallet,
  MdFlight,
  MdHotel,
  MdAccountCircle,
  MdViewList,
  MdCalendarMonth,
  MdOutlineSupportAgent,
  MdPhone,
  MdEmail,
  MdCalculate,
  MdDeleteForever,
} from 'react-icons/md';
import {
  LuBedDouble,
  LuShieldCheck,
  LuGlobe2,
  LuBus,
  LuPlane,
  LuTrain,
} from 'react-icons/lu';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  logoutApi,
  getAgentBalanceApi,
  getMessageFromAdmin,
  emulateUserApi,
  loginWithSSOApi,
  getAllIdentities,
  deleteAccountApi,
} from '../../../api/profileApi';
import {
  getStringFromLS,
  getObjectFromLS,
  clearLocalStorage,
  setStringInLs,
  removeDataInLS,
  setDataInLS,
  getUserAgentId,
} from '../../helper-utils/localStorage';
import { NAVIGATION_ROUTES } from '../../constants/Constants';
import AppModal from '../app-modal/AppModal';
import './AppHeader.scss';
import AppLoading from '../../components/app-loading/AppLoading';
import AppSidebar from '../app-sidebar/AppSidebar';
import {
  formatCurrency,
  getResponseFromEncyptedText,
  isMobileWidth,
} from '../../helper-utils/appUtils';
import AppButton from '../app-button/AppButton';
import AppLink from '../app-link/AppLink';
import ImportPnr from '../../../features/profile/import-pnr/ImportPnr';
import AppAlert from '../app-alert/AppAlert';
import AppSelect from '../app-select/AppSelect';
import { getAppConstants } from '../../../api/loginApi';
import Calculator from '../Calculator';
import { useAppContext } from '../../../saas/AppConfigWrapper';
import {
  APP_LOGO_URL,
  APP_SWITCHBACK_AUTH_TOKEN,
  APP_USER_AUTH,
  APP_USER_PROFILE,
} from '../../../saas/AppStorageStaticNames';

const FLIGHT = 'flight';
const HOTEL = 'hotel';
const ACCOUNT = 'account';
const BUS = 'bus';
const VISA = 'visa';
const INSURANCE = 'insurance';
const TRAIN = 'train';
const CALENDER = 'calender';

function AppHeader() {
  const intl = useIntl();
  const { appConfig } = useAppContext();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const userAuth = getStringFromLS(APP_USER_AUTH);
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const navigate = useNavigate();
  // const [showSalesRepDetails, setShowSalesRepDetails] = useState(false);
  const [activeTab, setActiveTab] = useState(FLIGHT);
  const [isLoading, setIsLoading] = useState(false);
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [userAccount, setUserAccount] = useState(undefined);
  const [adminMessages, setAdminMessages] = useState([]);
  const [showAdminMessagePopup, setShowAdminMessagePopup] = useState(false);
  const [selectedAdminMessageIndex, setSelectedAdminMessageIndex] = useState(0);
  const [showImportPnrModal, setShowImportPnrModal] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [emulatedOptions, setEmulatedOptions] = useState([]);
  const allEmulatedOptionsRef = useRef([]);
  const [selectedEmulateduser, setSelectedEmulatedUser] = useState('');
  const [showCalculate, setShowCalculate] = useState(false);
  const switchBackUserAuth = getStringFromLS(APP_SWITCHBACK_AUTH_TOKEN);
  const [config, setConfig] = useState({
    showTrains: appConfig.hasTrain,
    showBuses: appConfig.hasBus,
    showFlights: appConfig.hasFlight,
    showInsurance: appConfig.hasInsurance,
    showHotels: appConfig.hasHotel,
  });
  const [showEraseDataPopup, setShowEraseDataPopup] = useState(false);

  const getAgentBalance = async () => {
    const response = await getAgentBalanceApi();
    if (response.ApiStatus.Status === 'OK') {
      const { UserAccount } = response.ApiStatus.Result;
      setUserAccount(UserAccount);
    }
  };

  const handleGetAdminMessages = async () => {
    setIsLoading(true);
    const res = await getMessageFromAdmin();
    if (res && res.Root && res.Root.Status === 'OK') {
      const { AdminMessage } = res.Root.Result;
      const list = Array.isArray(AdminMessage) ? AdminMessage : [AdminMessage];
      setAdminMessages(list);
    }
    setShowAdminMessagePopup(true);
    setIsLoading(false);
  };

  const handleShowPrevMsg = () => {
    let index = selectedAdminMessageIndex;
    if (index === 0) {
      return;
    }
    if (index > 0) {
      index -= 1;
      setSelectedAdminMessageIndex(index);
    }
  };

  const handleShowNextMsg = () => {
    let index = selectedAdminMessageIndex;
    if (index === adminMessages.length - 1) {
      return;
    }
    if (index < adminMessages.length) {
      index += 1;
      setSelectedAdminMessageIndex(index);
    }
  };

  const getAgentsList = async () => {
    const response = await getAllIdentities();
    if (response) {
      const { Result } = response.Root;
      const { ProfileMasters } = Result;
      let { ProfileMaster } = ProfileMasters;
      ProfileMaster = Array.isArray(ProfileMaster)
        ? ProfileMaster
        : [ProfileMaster];
      const options = ProfileMaster.map((p) => ({
        label: `${p.CorporateName} ${p.CorporateId} - ${p.City}`,
        value: p.CorporateId,
      }));
      allEmulatedOptionsRef.current = options;
      setEmulatedOptions(options.slice(0, 5));
    }
  };

  useEffect(() => {
    if (userAuth !== null && userProfile !== null) {
      getAgentBalance();
      if (
        userProfile &&
        (userProfile.systemRoleId === '1' || userProfile.systemRoleId === '2')
      ) {
        getAgentsList();
      }
    }

    const agentId = getUserAgentId();
  }, []);

  const handleOnClick = (tab) => {
    setActiveTab(tab);
    if (tab === FLIGHT) {
      navigate(NAVIGATION_ROUTES.LANDING);
    } else if (tab === HOTEL) {
      navigate(NAVIGATION_ROUTES.HOTEL.LANDING);
    } else if (tab === ACCOUNT) {
      navigate('/my-bookings');
    } else if (tab === CALENDER) {
      navigate(NAVIGATION_ROUTES.PASSENGER_CALENDER);
    }
    setShowSideMenu(false);
  };

  const getSelectedTab = () => {
    if (window.location.pathname.split('/')[1] === 'flight') {
      setActiveTab(FLIGHT);
    }
    if (window.location.pathname.split('/')[1] === 'hotel') {
      setActiveTab(HOTEL);
    }
    if (window.location.pathname.split('/')[1] === 'bus') {
      setActiveTab(BUS);
    }
    if (window.location.pathname.split('/')[1] === 'visa') {
      setActiveTab(VISA);
    }
    if (window.location.pathname.split('/')[1] === 'insurance') {
      setActiveTab(INSURANCE);
    }
    if (window.location.pathname.split('/')[1] === 'passenger-calender') {
      setActiveTab(CALENDER);
    }
    if (window.location.pathname.split('/')[1] === 'my-bookings') {
      setActiveTab(ACCOUNT);
    }
  };

  useEffect(() => {
    getSelectedTab();
  }, [window.location.pathname]);

  const handleLogout = async () => {
    setIsLoading(true);
    const res = await logoutApi();
    if (res?.ApiStatus.Status === 'OK') {
      window.location.href = NAVIGATION_ROUTES.LOGIN;
      clearLocalStorage();
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  const handleMenuClick = () => {
    navigate('/profile');
    setShowSideMenu(false);
  };
  const handleOnTabClickInMobile = (tab) => {
    setShowSideMenu(false);
    navigate(`/search?searchtype=${tab}`);
    setActiveTab(tab);
  };

  const handleImportPnrModalClose = (isSuccess, importAlert) => {
    if (isSuccess) {
      setShowImportPnrModal(false);
    }
    setAlert(importAlert);
  };

  const handleChange = (val) => {
    if (val !== '') {
      const filtered = allEmulatedOptionsRef.current.filter((option) =>
        option.label.toLowerCase().includes(val.toLowerCase()),
      );
      setEmulatedOptions(filtered.slice(0, 5));
    } else {
      setEmulatedOptions(allEmulatedOptionsRef.current.slice(0, 5));
    }
  };

  const getEmulateUserDashboard = async (Result) => {
    const loginResponse = await loginWithSSOApi(Result);
    if (
      loginResponse === undefined ||
      loginResponse.ApiStatus.StatusCode !== 200
    ) {
      setAlert({
        title: 'Emulate',
        description: `Login Failed, ${
          loginResponse ? loginResponse.ApiStatus.Message : ''
        }`,
        variant: 'error',
      });
      setIsLoading(false);
      removeDataInLS(APP_SWITCHBACK_AUTH_TOKEN);
    } else {
      const profileInfo = loginResponse.ApiStatus.Result.split('@@@');
      const profile = {
        agentId: profileInfo[0],
        profileId: profileInfo[1],
        title: profileInfo[2],
        firstName: profileInfo[3],
        lastName: profileInfo[4],
        systemRoleId: profileInfo[5],
        companyName: profileInfo[6],
      };
      setDataInLS(APP_USER_PROFILE, profile);
      setStringInLs(APP_USER_AUTH, loginResponse.ApiStatus.TransactionStatus);
      window.location.href = NAVIGATION_ROUTES.LANDING;
    }
  };

  const handleEmulate = async () => {
    if (selectedEmulateduser !== '' && selectedEmulateduser !== null) {
      setIsLoading(true);
      const emulateResponnse = await emulateUserApi(selectedEmulateduser);
      if (emulateResponnse && emulateResponnse.ApiStatus?.Status === 'OK') {
        const { Result } = emulateResponnse.ApiStatus;
        setStringInLs(APP_SWITCHBACK_AUTH_TOKEN, userAuth);
        await getEmulateUserDashboard(Result);
      } else {
        setAlert({
          title: 'Emulate',
          description: emulateResponnse
            ? emulateResponnse.ApiStatus.Message
            : 'Failed to emulate. Please try again.',
          variant: 'error',
        });
        setIsLoading(false);
      }
    }
  };

  const handleDeleteAccountForAppUser = async () => {
    setIsLoading(true);
    setShowEraseDataPopup(false);
    const response = await deleteAccountApi(userProfile?.profileId);
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      setAlert({
        title: 'Delete Account',
        description: 'Account deleted successfully',
        variant: 'success',
      });
      setTimeout(() => {
        clearLocalStorage();
        window.location.href = NAVIGATION_ROUTES.LOGIN;
      }, 2000);
    } else {
      setAlert({
        title: 'Delete Account',
        description: 'Failed to delete the account',
        variant: 'error',
      });
    }
    setIsLoading(false);
  };

  return (
    <Navbar className="app-header py-0" expand="lg" collapseOnSelect>
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      <Row className="spacing-8">
        <Col lg={3} md={3} sm={6} xs={6} className="mt-0">
          <div
            className="py-1 d-flex align-items-center"
            style={{ height: '70px' }}
          >
            <NavLink to="/" className="cursor-pointer app-header-logo">
              <img
                src={`${
                  appConfig?.appMainUrl
                }printlogos/${getUserAgentId()}.gif`}
                alt=""
                style={{ maxHeight: `${appConfig.logoHeight}px` }}
                onError={(e) => (e.target.src = getStringFromLS(APP_LOGO_URL))}
              />
            </NavLink>
          </div>
        </Col>
        <Col
          lg={9}
          md={9}
          sm={6}
          xs={6}
          className="d-flex justify-content-end align-items-center mt-0 gap-2"
        >
          <div className="flex-1 d-sm-flex d-none">
            {userAuth !== null &&
              userProfile !== null &&
              (userProfile.systemRoleId === '1' ||
                userProfile.systemRoleId === '2') && (
                <div className="d-flex gap-3 fs-12 mt-2 align-items-center">
                  <div>
                    <AppSelect
                      name=""
                      options={emulatedOptions}
                      onSelect={(dataObj) =>
                        setSelectedEmulatedUser(dataObj.value)
                      }
                      onInputChange={handleChange}
                      selectedValue={selectedEmulateduser}
                      label="Select Agent"
                      selectWidth="250px"
                      placeholder=""
                      isClearable={false}
                    />
                  </div>
                  <div>
                    <AppButton
                      btnText="Emulate"
                      variant="outlined"
                      onClick={handleEmulate}
                      className="emulate-btn"
                    />
                  </div>
                </div>
              )}
            {userAuth !== null &&
              userProfile !== null &&
              switchBackUserAuth !== null &&
              switchBackUserAuth !== '' && (
                <div className=" d-flex align-items-center justify-content-end flex-1">
                  <AppButton
                    btnText="Switch Back"
                    variant="outlined"
                    onClick={() => {
                      getEmulateUserDashboard(switchBackUserAuth);
                      removeDataInLS(APP_SWITCHBACK_AUTH_TOKEN);
                    }}
                    className="emulate-btn fs-12 my-1"
                  />
                </div>
              )}
          </div>
          <div className="d-flex flex-column align-items-end">
            <div className="d-flex gap-3">
              {userAuth !== null && userProfile !== null && (
                <div className="d-flex gap-3 align-items-center">
                  <div className="app-header-options d-mobile-none">
                    <div className="d-flex gap-3 align-items-center fs-5 ">
                      {config.showFlights && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip>
                              <div>Flight Booking</div>
                            </Tooltip>
                          }
                        >
                          <NavLink
                            to="/search?searchtype=flight"
                            className={`d-flex justify-content-center  cursor-pointer ${
                              activeTab === FLIGHT
                                ? 'primary-color'
                                : 'dark-grey-color '
                            }`}
                          >
                            <LuPlane />
                          </NavLink>
                        </OverlayTrigger>
                      )}
                      {config.showHotels && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip>
                              <div>Hotel Booking</div>
                            </Tooltip>
                          }
                        >
                          <NavLink
                            to="/search?searchtype=hotel"
                            className={`d-flex justify-content-center cursor-pointer ${
                              activeTab === HOTEL
                                ? 'primary-color'
                                : 'dark-grey-color'
                            }`}
                          >
                            <LuBedDouble />
                          </NavLink>
                        </OverlayTrigger>
                      )}
                      {config.showBuses && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip>
                              <div>Bus Booking</div>
                            </Tooltip>
                          }
                        >
                          <NavLink
                            to="/search?searchtype=bus"
                            className={`d-flex justify-content-center  cursor-pointer ${
                              activeTab === BUS
                                ? 'primary-color'
                                : 'dark-grey-color '
                            }`}
                          >
                            <LuBus />
                          </NavLink>
                        </OverlayTrigger>
                      )}
                      {config.showTrains && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip>
                              <div>Train Booking</div>
                            </Tooltip>
                          }
                        >
                          <NavLink
                            to="/search?searchtype=train"
                            className={`d-flex justify-content-center  cursor-pointer ${
                              activeTab === TRAIN
                                ? 'primary-color'
                                : 'dark-grey-color '
                            }`}
                          >
                            <LuTrain />
                          </NavLink>
                        </OverlayTrigger>
                      )}
                      {config.showInsurance && (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip>
                              <div>Insurance</div>
                            </Tooltip>
                          }
                        >
                          <NavLink
                            to="/insurance"
                            className={`d-flex justify-content-center  cursor-pointer ${
                              activeTab === INSURANCE
                                ? 'primary-color'
                                : 'dark-grey-color '
                            }`}
                          >
                            <LuShieldCheck />
                          </NavLink>
                        </OverlayTrigger>
                      )}
                    </div>
                  </div>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip>
                        <div>Travel Calender</div>
                      </Tooltip>
                    }
                  >
                    <NavLink
                      to={NAVIGATION_ROUTES.PASSENGER_CALENDER}
                      className={`fs-5 d-flex justify-content-center d-mobile-none cursor-pointer ${
                        activeTab === 'calender'
                          ? 'primary-color'
                          : 'dark-grey-color '
                      }`}
                    >
                      <MdCalendarMonth />
                    </NavLink>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip>
                        <div>Calculator</div>
                      </Tooltip>
                    }
                  >
                    <div className="fs-5 d-flex justify-content-centercursor-pointer d-mobile-none cursor-pointer">
                      <MdCalculate onClick={() => setShowCalculate(true)} />
                    </div>
                  </OverlayTrigger>

                  {/* <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip>
                        <div>Support</div>
                      </Tooltip>
                    }
                  >
                    <div className="fs-5 d-flex justify-content-centercursor-pointer d-mobile-none cursor-pointer">
                      <MdOutlineSupportAgent
                        onClick={() => setShowSalesRepDetails(true)}
                      />
                    </div>
                  </OverlayTrigger> */}
                  <AppLink
                    variant="black"
                    className="fs-12 app-header-updates d-mobile-none"
                    onClick={handleGetAdminMessages}
                    linkText="Updates"
                  />

                  <div className="mobile-menu">
                    {/* <div className="fs-2 d-flex justify-content-centercursor-pointer align-items-center">
                      <MdOutlineSupportAgent
                        onClick={() => setShowSalesRepDetails(true)}
                      />
                    </div> */}
                    <MdMenu onClick={() => setShowSideMenu((prev) => !prev)} />
                  </div>
                  <NavDropdown
                    className="fs-12 d-mobile-none"
                    title={
                      <div className="d-flex flex-column ">
                        <span>{`${userProfile?.firstName} ${userProfile?.lastName}`}</span>
                        <span>{userProfile?.agentId}</span>
                      </div>
                    }
                  >
                    <NavDropdown.Item onClick={() => navigate('/profile')}>
                      <FormattedMessage id="profile" />
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleOnClick(ACCOUNT)}>
                      <FormattedMessage id="accounts" />
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => navigate('/flight/hold-queues')}
                    >
                      Hold Queues
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item
                      onClick={() => setShowSalesRepDetails(true)}
                    >
                      <FormattedMessage id="support" />
                    </NavDropdown.Item> */}
                    <NavDropdown.Item
                      onClick={handleLogout}
                      className="log-out-btn"
                    >
                      <FormattedMessage id="logout" />
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              )}
            </div>
            {!isMobileWidth() && (
              <div>
                {userAccount && (
                  <div className="d-flex align-items-center gap-1 fs-12">
                    <span>
                      Available Balance :{' '}
                      <b
                        className="global-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(
                          userAccount.Balance +
                            userAccount.CreditLimit -
                            userAccount.Due,
                        )}
                      </b>
                    </span>
                    {' | '}{' '}
                    <span>
                      Credit Limit :{' '}
                      <b
                        className="global-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(userAccount.CreditLimit)}
                      </b>
                    </span>
                    {' | '}
                    <span>
                      Due :{' '}
                      <b
                        className="global-watermarked"
                        data-watermark={`${getUserAgentId()}`}
                      >
                        {formatCurrency(userAccount.Due)}
                      </b>
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>
      {showSideMenu && (
        <AppSidebar
          sidebarTitle={
            <div className="d-flex flex-column ">
              <span>{`${userProfile?.firstName} ${userProfile?.lastName}(${userProfile?.agentId})`}</span>
              <span className="fs-12">
                Helpline Number 24*7:{' '}
                <a href="tel:" style={{ textDecoration: 'none' }}>
                  011- 61224567
                </a>
              </span>
            </div>
          }
          onHideSidebar={() => setShowSideMenu(false)}
          animatedClass="slide-from-right-animation"
          modalClassName="app-header-menu"
        >
          <div className="w-100 app-header_navigation d-mobile-none">
            <div className="max-width">
              <div className="app-header_navigation_container">
                {userAccount && (
                  <div className="app-header_navigation_balance-info">
                    <div className="d-flex gap-2">
                      <MdAccountBalanceWallet />
                      <span className="d-flex flex-1 justify-content-between align-items-center">
                        {formattedMessage('available_balance')} :{' '}
                        <span className="fw-600">
                          {formatCurrency(
                            userAccount.Balance +
                              userAccount.CreditLimit -
                              userAccount.Due,
                          )}
                        </span>
                      </span>
                    </div>
                    <div
                      className="d-flex flex-column gap-1"
                      style={{ paddingLeft: '26px' }}
                    >
                      <span className="d-flex flex-1 justify-content-between align-items-center">
                        <span>{formattedMessage('credit_limit')}: </span>
                        <span className="fw-600">
                          {formatCurrency(userAccount.CreditLimit)}
                        </span>
                      </span>
                      <span className="d-flex flex-1 justify-content-between align-items-center">
                        {formattedMessage('due')}:{' '}
                        <span className="fw-600">
                          {formatCurrency(userAccount.Due)}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
                <button
                  className={activeTab === FLIGHT ? 'active-btn' : ''}
                  onClick={() => handleOnTabClickInMobile(FLIGHT)}
                >
                  <LuPlane /> <FormattedMessage id="flight_tab" />
                </button>
                {appConfig.hasHotel && (
                  <button
                    className={activeTab === HOTEL ? 'active-btn' : ''}
                    onClick={() => handleOnTabClickInMobile(HOTEL)}
                  >
                    <LuBedDouble /> <FormattedMessage id="hotel_tab" />
                  </button>
                )}
                {appConfig.hasBus && (
                  <button
                    className={activeTab === BUS ? 'active-btn' : ''}
                    onClick={() => handleOnTabClickInMobile(BUS)}
                  >
                    <LuBus /> Bus
                  </button>
                )}
                {/* <button
                  className={activeTab === TRAIN ? 'active-btn' : ''}
                  onClick={() => handleOnTabClickInMobile(TRAIN)}
                >
                  <LuTrain /> Train
                </button> */}
                {appConfig.hasInsurance && (
                  <button
                    className={activeTab === INSURANCE ? 'active-btn' : ''}
                    onClick={() => navigate('/insurance')}
                  >
                    <LuShieldCheck /> Insurance
                  </button>
                )}
                <button onClick={() => handleMenuClick()}>
                  <MdAccountCircle /> <FormattedMessage id="profile" />
                </button>
                <button
                  className={activeTab === ACCOUNT ? 'active-btn' : ''}
                  onClick={() => handleOnClick(ACCOUNT)}
                >
                  <MdViewList /> <FormattedMessage id="accounts" />
                </button>
                <button
                  onClick={() => handleOnClick(CALENDER)}
                  className={activeTab === 'calender' ? 'active-btn' : ''}
                >
                  <MdCalendarMonth /> Travel Calender
                </button>
                {!isMobileWidth() && (
                  <button onClick={handleGetAdminMessages}>Updates</button>
                )}
                <button onClick={handleLogout} className="logout-btn">
                  <MdLogout /> <FormattedMessage id="logout" />
                </button>
              </div>
            </div>
          </div>
        </AppSidebar>
      )}
      {/* {showSalesRepDetails && (
        <AppModal
          modalTitle="Help & Support"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={() => setShowSalesRepDetails(false)}
          backdrop="renderbackdrop"
        >
          <div className="d-flex flex-column">
            <div className="text-center secondary-color fs-16 py-1">
              Looking for Help & Assistance?
            </div>
            <div className="primary-color  fs-16 py-1 fw-600 text-center">
              Contact Us
            </div>
          </div>
        </AppModal>
      )} */}
      {showEraseDataPopup && (
        <AppModal
          modalTitle="Are you sure!"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={() => setShowEraseDataPopup(false)}
          backdrop="renderbackdrop"
        >
          <section>
            <div className="d-flex flex-column">
              <span>
                Do you want to delete your account? This action is irreversible
                and will permanently delete all your account information.
              </span>
              <div className="d-flex justify-content-end">
                <AppButton
                  btnText="Delete Account"
                  onClick={handleDeleteAccountForAppUser}
                />
              </div>
            </div>
          </section>
        </AppModal>
      )}
      {showImportPnrModal && (
        <AppModal
          modalTitle="Import PNR"
          showFooter={false}
          showCloseButton
          className="sales-rep-details fs-14"
          onModalClose={() => setShowImportPnrModal(false)}
        >
          <ImportPnr onClose={handleImportPnrModalClose} />
        </AppModal>
      )}
      {showCalculate && <Calculator onClose={() => setShowCalculate(false)} />}
      {showAdminMessagePopup && (
        <AppModal
          modalTitle="Message From Admin"
          showCloseButton={false}
          // backdrop="render-backdrop"
          onModalClose={() => setShowAdminMessagePopup(false)}
        >
          {adminMessages.length > 0 ? (
            <div className="d-flex flex-column align-items-center fs-14">
              <div className="d-flex justify-content-between align-items-center w-100">
                <AppLink
                  variant="secondary"
                  linkText={
                    selectedAdminMessageIndex === 0 ? '' : 'Prev Message'
                  }
                  onClick={handleShowPrevMsg}
                />
                <AppLink
                  variant="secondary"
                  linkText={
                    selectedAdminMessageIndex === adminMessages.length - 1
                      ? ''
                      : 'Next Message'
                  }
                  onClick={handleShowNextMsg}
                />
              </div>
              <p className="fw-600">
                {adminMessages[selectedAdminMessageIndex]?.MessageTitle}
              </p>
              <span>
                {adminMessages[selectedAdminMessageIndex]?.MessageDescription}
              </span>
            </div>
          ) : (
            <div className="fs-14 fw-500 text-center">
              No Messages From Admin
            </div>
          )}
          <div className="d-flex justify-content-end">
            <AppButton
              btnText="Close"
              variant="outlined"
              onClick={() => setShowAdminMessagePopup(false)}
            />
          </div>
        </AppModal>
      )}
    </Navbar>
  );
}

export default AppHeader;
